import { Dayjs } from 'dayjs'
import { ExpandedEvent } from './createEventPayloadBuilder'

export const buildOriginalEventsMap = (events: ExpandedEvent[]): Map<number, ExpandedEvent> => {
  const map = new Map<number, ExpandedEvent>()
  events.forEach(e => map.set(e.key, { ...e, crewMemberIds: [...e.crewMemberIds] }))
  return map
}

export const isEventFieldChanged = (
  record: ExpandedEvent,
  field: keyof ExpandedEvent,
  originalEventsMap: Map<number, ExpandedEvent>,
): boolean => {
  const original = originalEventsMap.get(record.key)
  if (!original) {
    return false
  }

  if (field === 'startDate' || field === 'startTime') {
    return !record[field].isSame(original[field], 'minute')
  }

  if (field === 'duration') {
    return record.duration.seconds !== original.duration.seconds
  }

  if (field === 'crewMemberIds') {
    const curr = [...record.crewMemberIds].sort()
    const orig = [...original.crewMemberIds].sort()
    return curr.length !== orig.length || curr.some((id, i) => id !== orig[i])
  }

  if (field === 'crewLeadId') {
    return record.crewLeadId !== original.crewLeadId
  }

  return false
}

export const shiftedEndDate = (currentStartDate: Dayjs, currentEndDate: Dayjs, newStartDate: Dayjs): Dayjs => {
  const span = currentEndDate.diff(currentStartDate, 'days')
  return newStartDate.add(span, 'days')
}
